import * as React from 'react';

import type { EventElementProps } from './event-element-props.interface';
import { Note } from '../note/Note';

export const EventNote = ({ data }: EventElementProps) => (
  <Note
    id={data.id}
    body={data.body}
    senderType={data.sender_type}
    senderId={data.sender_id}
    senderTag={data.sender_tag}
    sentAt={data.sent_at}
  />
);
